/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Container,
  Paper,
  Breadcrumbs,
  Link as MuiLink,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Tab,
  Tabs,
  Skeleton,
  Tooltip,
} from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { styled, useTheme } from '@mui/material/styles';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectUserRole } from 'renderer/features/auth/state/userSelectors';
import AddIcon from '@mui/icons-material/Add';
import { formatCurrency } from 'renderer/shared/formatters/formatters';
import { useGoogleAds } from 'renderer/shared/analytics';
import _ from 'lodash';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useListProductsQuery } from '../services/products.endpoints';
import productThumbnails from '../constants/productThumbnails';
import PurchaseDialog from './PurchaseDialog';
import { categoryIdToName } from '../constants/storeTabs';
import { useAddToCartMutation } from '../../payments-page/services/cart.endpoints';
import AuthorizeDialog from './AuthorizeDialog';
import { getProductStorePath } from '../utils/productPath';

// const LazyImg = ({ src, alt, sx }) => {
// const LazyImg = () => {
//   const ref = React.useRef(null);
//   const [loaded, setLoaded] = React.useState(false);

//   React.useEffect(() => {
//     const el = ref.current;
//     if (!el) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting) {
//           setLoaded(true);
//           observer.disconnect();
//         }
//       },
//       { rootMargin: '100px' },
//     );

//     observer.observe(el);
//     return () => observer.disconnect();
//   }, []);
// };

type LazyImgProps = {
  src: string;
  alt: string;
};

const LazyImg: React.FC<LazyImgProps> = ({ src, alt }) => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current!;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setLoaded(true);
          observer.disconnect();
        }
      },
      { rootMargin: '150px' },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
      }}
    >
      {loaded ? (
        <img
          src={src}
          alt={alt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            display: 'block',
            opacity: 1,
            transition: 'opacity 0.3s ease',
          }}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ bgcolor: '#eee' }}
        />
      )}
    </Box>
  );
};

const baseUrl = `${process.env.SERVER_URL ?? 'http://localhost:3000'}/api`;
const HeroBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // true for xs

  return (
    <Box
      sx={{
        background: 'linear-gradient(90deg, #1c1c1c 0%, #444 100%)',
        color: 'white',
        padding: '24px',
        borderRadius: '8px',
        mb: 4,
        textAlign: 'center',
        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
      }}
    >
      <Typography
        variant="h4"
        component="div"
        sx={{
          fontWeight: 'bold',
          mb: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
        }}
      >
        Smart Tools for Creative Minds
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          maxWidth: '800px',
          margin: '0 auto',
          opacity: 0.9,
        }}
      >
        Our award-winning plugins are today&#39;s industry standard for video
        editing, visual effects, and post-production. All plugins are available
        as a single license or a yearly subscription!
      </Typography>
    </Box>
  );
};

const StyledCardMedia = styled(CardMedia)(() => ({
  height: 140,
  margin: '0 auto 25px',
  width: '100%',
  maxWidth: '100%',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundColor: '#fff',
}));

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: 2,
  border: '1px solid rgba(0,0,0,0.12)',
  position: 'relative',
  '&:hover .hover-overlay': {
    // opacity: 1,
    cursor: 'pointer',
  },
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  // padding: '16px 16px 8px',
  // padding: 8,
  padding: '8px 5px',
  textAlign: 'center',
  '&:last-child': {
    paddingBottom: theme.spacing(1.2), // Reduce padding at the bottom of CardContent
  },
  '& .MuiTypography-body2': {
    display: '-webkit-box',
    WebkitLineClamp: 2, // Limit text to 2 lines
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .MuiTypography-h5': {
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
  },
  '& .MuiTypography-h6': {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    // marginBottom: theme.spacing(2), // Ensure consistent spacing above the card actions
  },
}));

const Badge = styled(Box)(({ theme }) => ({
  backgroundColor: '#D32F2F',
  color: '#fff',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  padding: '2px 6px',
  borderRadius: '2px',
}));

const NewBadge = styled(Badge)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

const ProductsPage = () => {
  useGoogleAds('home');

  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const navigate = useNavigate();
  const [dialogHostApp, setDialogHostApp] = useState<{
    id: string;
    displayName: string;
    version: string;
  } | null>(null);
  const [sortValue, setSortValue] = useState('default');
  const [searchTerm, setSearchTerm] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    null,
  );
  const { categoryId } = useParams();
  const category = categoryIdToName[categoryId ?? ''] ?? 'Video Plugin';

  const handleSortChange = (event: any) => {
    setSortValue(event.target.value);
  };

  const role = useAppSelector(selectUserRole);
  const {
    data: products,
    isLoading,
    error,
  } = useListProductsQuery({ includeHidden: role === 'admin' });
  console.log('list products error', error);

  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm')); // true on tablets/desktop

  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchTerm), 250);
    return () => clearTimeout(t);
  }, [searchTerm]);

  useEffect(() => {
    if (category === 'Upgrade') {
      setSortValue('priceHighLow');
    }
  }, [category]);

  const sortAndFilterProducts = () => {
    const productsCopy = _.cloneDeep(products);
    const isDeals = categoryId === 'deals';

    let filtered =
      productsCopy &&
      productsCopy.filter((product) => {
        const matchesSearch = (product.name ?? '')
          .toLocaleLowerCase()
          .includes(debouncedSearch.toLowerCase());

        const isOnSale =
          product.sale?.salePrice && new Date(product.sale.until) > new Date();

        // DEALS tab logic
        if (isDeals) {
          return isOnSale && matchesSearch;
        }

        // If search term is empty, filter strictly by category
        if (!debouncedSearch) {
          return product.category === category;
        }

        // If searching, match any product that includes the term
        return matchesSearch;
      });

    filtered = filtered || [];

    if (sortValue === 'priceLowHigh') {
      filtered = filtered.sort((a, b) => a.startingPrice - b.startingPrice);
    } else if (sortValue === 'priceHighLow') {
      filtered = filtered.sort((a, b) => b.startingPrice - a.startingPrice);
    }

    return filtered;
  };

  const sortedFilteredProducts = sortAndFilterProducts();

  const [addToCart] = useAddToCartMutation();

  const handlePurchaseClick = async (
    productId: string,
    productCategory: string,
    productName: string,
    product: any,
  ) => {
    const isSubscription = productCategory === 'Subscription';

    if (!isSubscription) {
      // Non-subscription logic remains unchanged
      if (
        productCategory === 'Video Plugin' &&
        !productName.toLowerCase().includes('anarchy complete bundle')
      ) {
        const host =
          product.supportedHostApplications?.length === 1
            ? product.supportedHostApplications[0]
            : null;
        setDialogHostApp(host);
        setSelectedProductId(productId);
        setModalOpen(true);
        return;
      }

      navigate(
        getProductStorePath(product, { exactVersion: role === 'admin' }),
      );
      return;
    }

    const isAllAccess = productName.toLowerCase().includes('all access');
    const isOneHostApp = productName.toLowerCase().includes('one host');

    const platform = product.supportedPlatforms?.[0] ?? 'Windows';
    const hostApplication = isAllAccess
      ? product.supportedHostApplications?.[0] ?? null
      : null;

    try {
      await addToCart({
        productId,
        quantity: 1,
        platform,
        hostApplication,
      });

      navigate('/cart/1');
    } catch (err) {
      console.error('Failed to add subscription to cart:', err);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProductId(null);
    setDialogHostApp(null); // clear for next time
  };

  const handleNavigate = (path: string) => {
    setModalOpen(false);
    navigate(path);
  };

  const getDiscountPercent = (product: {
    startingPrice: number;
    salePrice: number | null;
    _id: string;
    category: string;
    productId: string;
    // productId:
    //   | 'placeholder'
    //   | 'cloud-all-access'
    //   | 'cloud-one-app'
    //   | 'cloud-complete-bundle-all-plugins'
    //   | 'eff-it'
    //   | 'beauty-box-crossgrade'
    //   | 'beauty-box-photo-upgrade'
    //   | 'beauty-box-photo'
    //   | 'beauty-box-upgrade-123'
    //   | 'beauty-box-upgrade'
    //   | 'beauty-box'
    //   | 'beauty-extreme'
    //   | 'beauty-flicker'
    //   | 'data-storyteller-crossgrade'
    //   | 'data-storyteller'
    //   | 'flicker-free-crossgrade'
    //   | 'flicker-free-upgrade'
    //   | 'flicker-free'
    //   | 'flicker-free-3'
    //   | 'flicker-free-upgrade-1to3'
    //   | 'flicker-free-upgrade-2to3'
    //   | 'lightwrap-crossgrade'
    //   | 'lightwrap'
    //   | 'powersearch'
    //   | 'samurai-sharpen-crossgrade'
    //   | 'samurai-sharpen'
    //   | 'transcriptive-upgrade'
    //   | 'transcriptive'
    //   | 'beauty-box-6'
    //   | 'beauty-box-6-upgrade-1to4'
    //   | 'beauty-box-6-upgrade-5to6';
    name: string;
    keywords: string;
    briefDescription: string;
    productPage: string;
    downloadPage: string;
    supportedPlatforms: string[];
    supportedHostApplications: {
      displayName: string;
      id: string;
      version: string;
    }[];
    fullDescription: string;
    fullPrice?: string | number | undefined;
    priority?: boolean | undefined;
    hidden?: boolean | undefined;
    upgradeId?: string | undefined;
    downgradeId?: string | undefined;
    sale?: { salePrice: number; until: string } | null | undefined;
    showBadge?: boolean | undefined;
    addOnId?: string | undefined;
    priceId?: string | undefined;
    subscriptionPlans?:
      | {
          quantity: number;
          price: number;
          planId: string;
          isActive: boolean;
          isNew: boolean;
          _id?: string | undefined;
          name?: string | undefined;
        }[]
      | undefined;
  }) => formatCurrency(product.sale!.salePrice);

  const getDisplayedPrice = (product: any) => {
    const now = new Date();
    const saleValid =
      product.sale &&
      product.sale.salePrice &&
      new Date(product.sale.until) > now;

    const displayPrice = saleValid
      ? product.sale.salePrice
      : product.startingPrice;
    // const formatted = formatCurrency(displayPrice);

    const formatted = formatCurrency(product.startingPrice);

    return product.category === 'Subscription'
      ? `${formatted}/year`
      : formatted;
  };

  return (
    <Container sx={{ px: 0, pb: 4 }}>
      {categoryId === 'deals' ? (
        <Box
          sx={{
            my: 2,
            py: 2,
            px: 3,
            marginBottom: 5,
            borderRadius: 2,
            background: 'linear-gradient(90deg, #ffe082, #ffca28)',
            textAlign: 'center',
            boxShadow: 2,
          }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: 'bold', color: '#5d4037' }}
          >
            🔥 Hot Deals on Now!
          </Typography>
          <Typography variant="subtitle1" sx={{ color: '#6d4c41' }}>
            Every product in this section is on sale for a limited time.
            Don&apos;t miss out!
          </Typography>
        </Box>
      ) : (
        <HeroBanner />
      )}
      <AuthorizeDialog
        open={authDialogOpen}
        onClose={() => setAuthDialogOpen(false)}
      />

      <Box
        sx={{
          my: 4,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 2, sm: 2 },
            width: '100%',
            px: { xs: 1, sm: 2 },
            py: { xs: 1, sm: 1.5 },
            backgroundColor: '#F5F5F5',
            borderRadius: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
          }}
        >
          {/* Search - flex grow */}
          <TextField
            id="search-products"
            placeholder="Search Products..."
            type="search"
            variant="outlined"
            size={isSmUp ? 'small' : 'medium'}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#616161' }} />
                </InputAdornment>
              ),
              sx: {
                backgroundColor: 'white',
                borderRadius: 1,
                boxShadow: 1,
                fontSize: { xs: 16, sm: 'inherit' },
                '& input': {
                  fontSize: { xs: 16, sm: 'inherit' },
                  lineHeight: { xs: '24px', sm: 'inherit' },
                },
                minHeight: { xs: 48, sm: 40 },
              },
            }}
            sx={{
              flexGrow: 1,
              minWidth: { xs: 240, sm: 0 },
            }}
          />

          {/* Dropdown - fixed width on desktop */}
          <FormControl
            size={isSmUp ? 'small' : 'medium'}
            sx={{
              minWidth: { xs: 'auto', sm: 180 },
              background: 'white',
              '& .MuiInputBase-root': {
                minHeight: { xs: 48, sm: 40 },
              },
              '& .MuiSelect-select': {
                fontSize: { xs: 16, sm: 'inherit' },
                display: 'flex',
                alignItems: 'center',
              },
            }}
          >
            <InputLabel id="sort-products-label">Sort by</InputLabel>
            <Select
              labelId="sort-products-label"
              id="sort-products"
              value={sortValue}
              label="Sort by"
              onChange={handleSortChange}
            >
              <MenuItem value="default">Default</MenuItem>
              <MenuItem value="priceLowHigh">Price: Low to High</MenuItem>
              <MenuItem value="priceHighLow">Price: High to Low</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {role === 'admin' && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => navigate('/products/add')}
          >
            Add Product
          </Button>
        </Box>
      )}

      <Grid container spacing={4}>
        {isLoading &&
          Array.from({ length: 5 }, (_, i) => (
            <Grid item key={i} xs={12} sm={6} md={3}>
              <Skeleton variant="rounded" width="100%" height={300} />
            </Grid>
          ))}

        {error && (
          <Typography>
            Error getting products {error && 'status' in error && error.status}
          </Typography>
        )}

        {sortedFilteredProducts?.length === 0 && (
          <Grid item xs={12}>
            <Box
              sx={{
                textAlign: 'center',
                // paddingY: 1,
              }}
            >
              <Typography variant="h6" color="text.primary" fontWeight={500}>
                No products found.
              </Typography>
            </Box>
          </Grid>
        )}

        {sortedFilteredProducts?.map((product) => (
          <Grid item xs={12} sm={6} md={4} key={product._id}>
            <StyledCard
              sx={{
                backgroundColor: '#fff',
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                  backgroundColor: '#111', // DARK background on hover
                },

                '&:hover .hover-overlay': {
                  opacity: 0.6,
                },
                '&:hover .product-name': {
                  color: '#fff',
                },
                '&:hover .hiddenIcon': {
                  color: '#fff',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 1,
                  pt: 1,
                  minHeight: 32,
                  flexWrap: 'nowrap',
                  overflow: 'hidden',
                  position: 'relative',
                  zIndex: 3, // above overlay
                }}
              >
                {product.sale?.salePrice &&
                  new Date(product.sale.until) > new Date() && (
                    <Badge>SALE</Badge>
                  )}
                {product.showBadge && <NewBadge>NEW</NewBadge>}
                <Typography
                  className="product-name"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    textTransform: 'uppercase',
                    color: '#000',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    // transition: 'color 0.2s ease',
                  }}
                >
                  {product.name}
                </Typography>

                {!!product.hidden && (
                  <Tooltip title="This item is hidden from customers.">
                    <VisibilityOffIcon
                      className="hiddenIcon"
                      color="action"
                      data-testid="product-hidden"
                    />
                  </Tooltip>
                )}
              </Box>

              <Link
                to={getProductStorePath(product, {
                  exactVersion: role === 'admin',
                })}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <StyledCardContent sx={{ position: 'relative', zIndex: 2 }}>
                  <Box sx={{ position: 'relative' }}>
                    {/* Overlay */}
                    <Box
                      className="hover-overlay"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#000',
                        opacity: 0,
                        zIndex: 1,
                        // transition: 'opacity 0.3s ease-in-out',
                      }}
                    />

                    {/* Product Image */}
                    {/* <StyledCardMedia
                      image={(() => {
                        const img = product.image as unknown;

                        if (!img) {
                          return productThumbnails.get(product.productId) ?? '';
                        }

                        // Case 1: string (safe cast)
                        if (typeof img === 'string') {
                          const strImg = img as string;
                          return strImg.startsWith('/uploads/')
                            ? `${baseUrl}${strImg}`
                            : strImg;
                        }

                        // Case 2: Mongo buffer object
                        if (
                          typeof img === 'object' &&
                          img !== null &&
                          'data' in (img as any) &&
                          (img as any).data
                        ) {
                          const typedImg = img as {
                            data: string | Uint8Array;
                            contentType?: string;
                          };
                          const base64 =
                            typeof typedImg.data === 'string'
                              ? typedImg.data
                              : Buffer.from(typedImg.data).toString('base64');
                          return `data:${
                            typedImg.contentType ?? 'image/png'
                          };base64,${base64}`;
                        }

                        // Fallback
                        return productThumbnails.get(product.productId) ?? '';
                      })()}
                      title={product.name}
                    /> */}
                    {/* <StyledCardMedia
                      image={
                        product.productImageId
                          ? `${baseUrl}/product-images/${product.productImageId}`
                          : productThumbnails.get(product.productId) ?? ''
                      }
                      title={product.name}
                    /> */}
                    {/* <StyledCardMedia>
                      <LazyImg
                        src={
                          product.productImageId
                            ? `${baseUrl}/product-images/${product.productImageId}`
                            : productThumbnails.get(product.productId) ?? ''
                        }
                        alt={product.name ?? ''}
                      />
                    </StyledCardMedia> */}

                    <StyledCardMedia>
                      <LazyImg
                        src={
                          product.productImageId
                            ? `${baseUrl}/product-images/${product.productImageId}`
                            : productThumbnails.get(product.productId) ?? ''
                        }
                        alt={product.name ?? ''}
                      />
                    </StyledCardMedia>

                    {product.sale?.salePrice &&
                    new Date(product.sale.until) > new Date() ? (
                      <Box
                        onClick={() =>
                          navigate(
                            getProductStorePath(product, {
                              exactVersion: role === 'admin',
                            }),
                          )
                        }
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          backgroundColor: '#263238',
                          color: '#fff',
                          p: 1,
                          mt: 1,
                          borderBottomLeftRadius: 2,
                          borderBottomRightRadius: 2,
                          cursor: 'pointer',
                          position: 'relative',
                          zIndex: 4, // stays on top
                        }}
                      >
                        {/* YOUR PRICE label on top, price below */}
                        <Box sx={{ lineHeight: 1.2 }}>
                          <Typography
                            sx={{
                              fontSize: '0.8rem',
                              opacity: 0.85,
                            }}
                          >
                            Price
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '1rem',
                              fontWeight: 'bold',
                              textDecoration: 'line-through',
                            }}
                          >
                            {getDisplayedPrice(product)}
                          </Typography>
                        </Box>

                        {/* Discount Circle */}
                        <Box
                          sx={{
                            position: 'relative',
                            width: 0,
                            height: 0,
                            flexGrow: 0,
                          }}
                        >
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '-37px',
                              right: '-50px',
                              width: '69px',
                              height: '71px',
                              borderRadius: '40px',
                              backgroundColor: '#D32F2F',
                              padding: 4.5,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '18px',
                              fontWeight: 'bold',
                              border: '2px solid white',
                              zIndex: 10,
                            }}
                          >
                            {getDiscountPercent(product)}
                            {/* {formatCurrency(product.sale.salePrice)} */}
                          </Box>
                        </Box>

                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            fontSize: '0.8rem',
                            px: 1.5,
                            minWidth: 0,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handlePurchaseClick(
                              product._id,
                              product.category,
                              product.name,
                              product,
                            );
                          }}
                        >
                          Buy Now
                        </Button>
                      </Box>
                    ) : (
                      // NO SALE FOOTER
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          backgroundColor: '#263238',
                          color: '#fff',
                          p: 1,
                          mt: 1,
                          borderBottomLeftRadius: 2,
                          borderBottomRightRadius: 2,
                          position: 'relative',
                          zIndex: 4, // stays on top
                        }}
                      >
                        <Box sx={{ lineHeight: 1.2 }}>
                          <Typography
                            sx={{ fontSize: '0.85rem', opacity: 0.85 }}
                          >
                            Starts from
                          </Typography>
                          <Typography
                            sx={{ fontWeight: 'bold', fontSize: '1rem' }}
                          >
                            {getDisplayedPrice(product)}
                          </Typography>
                        </Box>
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            fontSize: '0.85rem',
                            px: 1.5,
                            minWidth: 0,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handlePurchaseClick(
                              product._id,
                              product.category,
                              product.name,
                              product,
                            );
                          }}
                        >
                          Buy Now
                        </Button>
                      </Box>
                    )}
                  </Box>
                </StyledCardContent>
              </Link>
            </StyledCard>
          </Grid>
        ))}

        <Box
          sx={{
            mt: 6,
            px: 3,
            py: 3,
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            maxWidth: 1000,
            mx: 'auto',
            textAlign: 'center',
            color: '#222',
            fontSize: '1rem',
            lineHeight: 1.8,
          }}
        >
          <Typography component="div">
            Need help deciding what to buy or have questions? <br />
            <Box component="span" fontWeight="bold">
              Contact us at{' '}
              <Box
                component="a"
                href="mailto:sales@digitalanarchy.com"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                }}
              >
                sales@digitalanarchy.com
              </Box>{' '}
              or{' '}
              <Box
                component="a"
                href="tel:+14152876069"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                }}
              >
                (415) 287-6069
              </Box>
              !
            </Box>{' '}
            <br />
            Or you can go to our website,{' '}
            <Box
              component="a"
              href="https://www.digitalanarchy.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'inherit', textDecoration: 'none', fontWeight: 500 }}
            >
              www.digitalanarchy.com
            </Box>
            , to try out demos and tutorials before you purchase. <br />
            <br />
            <Box component="span" fontWeight="bold">
              Trouble Checking Out? <br />
            </Box>
            <Box component="span">
              You can also purchase at{' '}
              <Box
                component="a"
                href="https://store.digitalanarchy.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                }}
              >
                store.digitalanarchy.com
              </Box>
            </Box>
          </Typography>
        </Box>
      </Grid>

      <Box
        sx={{
          mt: 6,
          mb: 4,
          px: { xs: 1, sm: 2 },
          py: { xs: 1, sm: 1.5 },
          backgroundColor: '#ECEFF1',
          borderRadius: 1,
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease',
          display: 'flex', //  enable horizontal layout
          alignItems: 'center', // vertically center icon + text
          justifyContent: 'center', // center as a block
          gap: 1.5,
          '&:hover': {
            backgroundColor: '#CFD8DC',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          },
          '&:active': {
            backgroundColor: '#B0BEC5',
          },
          fontSize: { xs: '0.85rem', sm: '1rem' },
          textAlign: 'left',
        }}
        onClick={() => setAuthDialogOpen(true)}
      >
        <InfoOutlinedIcon
          sx={{ fontSize: '1.3rem', color: 'primary.main', flexShrink: 0 }}
        />
        <Typography sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
          Need to authorize a plugin or subscription? Click here for
          instructions.
        </Typography>
      </Box>

      <PurchaseDialog
        hostApp={dialogHostApp}
        platform=""
        products={products as any[]}
        open={modalOpen}
        onClose={handleCloseModal}
        onNavigate={handleNavigate}
        productId={selectedProductId}
      />
    </Container>
  );
};

export default ProductsPage;
